module.exports = __webpack_public_path__ + "fonts/Austin-Bold.ff7404bd.otf";